// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search[data-v-19b51dd3],.search[data-v-19b51dd3]:focus,.search[data-v-19b51dd3]:hover{position:relative;background-color:var(--dropdown-bg);border-radius:0;box-shadow:none}.results[data-v-19b51dd3]{margin-top:-1px;overflow-y:auto;padding:10px;color:var(--dropdown-text);background-color:var(--dropdown-bg);border:1px solid var(--dropdown-border);height:75vh}", ""]);
// Exports
module.exports = exports;
